// NEURACOM i18n — locale: en
// Auto-generated from translations.js refactor (iteration 25).
// Edit by namespace section. Keep keys in sync with en.js + it.js + pl.js.
const en = {
  common: {
    brand: "NEURACOM",
    brand_by: "by TelcaVoIP",
    get_started: "Get started",
    sign_in: "Sign in",
    sign_up: "Sign up",
    sign_out: "Sign out",
    dashboard: "Dashboard",
    pricing: "Pricing",
    features: "Features",
    contact: "Contact",
    loading: "Loading...",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    try_free: "Try for free",
    upgrade: "Upgrade",
    learn_more: "Learn more",
    coming_soon: "Coming soon",
    partner_program: "Partner Program",
    close: "Close",
  },
  pwa: {
    install_title: "Install NEURACOM",
    install_desc: "Add NEURACOM to your home screen for one-tap access — works offline too.",
    install_cta: "Install",
    install_later: "Later",
    install_ios_title: "Install NEURACOM on iPhone",
    install_ios_step1: "Tap",
    install_ios_step2: "then",
    install_ios_step3: "Add to Home Screen",
    update_title: "New version available",
    update_desc: "Reload now to get the latest features and fixes.",
    update_reload: "Reload",
    update_later: "Later",
    offline_badge: "Offline",
    offline_toast: "You're offline — some features may not work.",
    online_toast: "Back online.",
  },
  download: {
    pretitle: "Install as app",
    title: "Get NEURACOM on your phone",
    subtitle_desktop: "Scan the QR code with your phone camera. The app installs in 5 seconds — no App Store, no Play Store, no waiting for review.",
    subtitle_mobile: "Add NEURACOM to your home screen. Tap the button below and the app installs in 5 seconds.",
    chip_no_store: "No App Store needed",
    chip_offline: "Works offline",
    chip_native: "Native experience",
    chip_size: "Under 1 MB",
    install_now: "Install NEURACOM",
    no_store_note: "Direct install · no review · instant access",
    desktop_note: "Once installed, you'll get push notifications, voice input that works offline, and faster load times.",
    qr_caption_desktop: "Point your camera here",
    qr_caption_mobile: "Or scan from another device",
    installed_badge: "Already installed",
    installed_title: "You're all set — NEURACOM is on your home screen.",
    installed_desc: "Tap your home screen icon any time to launch the app.",
    ios_title: "Install on iPhone — 3 quick steps",
    ios_step_1: "Tap the Share button at the bottom of Safari",
    ios_step_2: "Scroll down and tap",
    ios_add_to_home: "Add to Home Screen",
    ios_step_3: "Confirm with 'Add' in the top-right corner",
  },
  landing: {
    hero_pretitle: "AI Platform for European Businesses",
    hero_title: "Build with AI. Ship anywhere.",
    hero_subtitle:
      "Multi-model chat, image generation, and AI code builder — all in one secure, multilingual workspace. Powered by NEURACOM, built by TelcaVoIP.",
    hero_cta_primary: "Start free — no card required",
    hero_cta_secondary: "View pricing",
    stat_models: "AI models",
    stat_languages: "Languages",
    stat_uptime: "Uptime SLA",
    stat_rulings: "Curated rulings",
    stat_gdpr_compact: "EU-hosted, GDPR",
    stat_kb: "Private notes",
    stat_gdpr: "100% compliant",
    hero_legal_chip: "Looking for Legal Pro?",
    legal_pretitle: "Legal Pro · For lawyers & DPOs",
    legal_title: "The first Italian AI legal assistant trained on Cassazione + CGUE.",
    legal_subtitle: "Stop pasting answers from generic ChatGPT into your briefs. NEURACOM Legal Pro reasons over 103 curated landmark rulings, cites your own private knowledge base, and writes in real Italian legal language.",
    legal_feat_jurisprudence_title: "103 landmark rulings",
    legal_feat_jurisprudence_desc: "Curated Cassazione (SS.UU. + Sezioni) and CGUE jurisprudence, searchable with native BM25 + auto-cite during chat.",
    legal_feat_knowledge_base_title: "Your private legal brain",
    legal_feat_knowledge_base_desc: "Save any ruling, AI answer or note to your encrypted personal KB. Pin, search, tag — your know-how grows with every case.",
    legal_feat_auto_cite_title: "Ambient citations",
    legal_feat_auto_cite_desc: "As you type, NEURACOM surfaces the 3 most relevant notes from your KB. Auto-KB mode injects them automatically — zero clicks.",
    legal_feat_gdpr_title: "EU-hosted, GDPR by design",
    legal_feat_gdpr_desc: "Data processed in EU, isolated per-account, never used to train external models. Article 22 GDPR safeguards included.",
    legal_workflow_pretitle: "How Legal Pro works",
    legal_workflow_title: "From research to ready-to-file in minutes.",
    legal_step_1_title: "Save jurisprudence with 1 click",
    legal_step_1_desc: "Browse the 103 curated Italian/EU rulings or upload your own PDFs. Pin the principles you reuse most often.",
    legal_step_2_title: "Chat in Legal Mode",
    legal_step_2_desc: "Toggle Legal Mode on. The AI auto-cites relevant rulings from the database — and from your own private KB.",
    legal_step_3_title: "Cite verbatim, no hallucinations",
    legal_step_3_desc: "Every citation is grounded in a real ruling or your saved note. Answers include the original court, ruling number, and date.",
    legal_step_4_title: "Export for your brief",
    legal_step_4_desc: "Copy the answer into your atto or memo — the language is already in formal Italian legal register.",
    legal_quote: "\"I used to spend 40 minutes searching Italgiure for the right ruling. With NEURACOM I have a draft with 3 verified citations in 90 seconds.\"",
    legal_quote_author: "Avv. M. (Studio Legale, Milano)",
    legal_quote_role: "Civil & commercial law · Legal Pro user",
    legal_use_contracts: "Contracts",
    legal_use_litigation: "Litigation",
    legal_use_gdpr: "GDPR & Privacy",
    legal_use_labor: "Labor law",
    legal_use_tax: "Tax & accounting",
    legal_use_real_estate: "Real estate",
    legal_price_unit: "/ month · cancel anytime",
    legal_price_note: "Includes Claude Opus 4.8, 1.000 chat msgs/mo, 100 PDF uploads, unlimited KB notes.",
    legal_cta_primary: "Start Legal Pro free trial",
    legal_cta_secondary: "Compare all plans",
    features_title: "One workspace. Every AI task.",
    features_subtitle:
      "Stop juggling tabs. NEURACOM gives your team Claude, GPT, Gemini, image generation and an AI code builder in a single branded platform.",
    feat_chat_title: "Multi-model AI Chat",
    feat_chat_desc:
      "Switch between Claude Sonnet 4.5, GPT-5.2 and Gemini 3 Flash in one chat. Pick the right brain for each task.",
    feat_image_title: "Image Generation Studio",
    feat_image_desc:
      "Generate stunning visuals with Gemini Nano Banana and OpenAI GPT-Image-1. Marketing, product mockups, social media.",
    feat_code_title: "AI Code Builder",
    feat_code_desc:
      "Describe an app in any language. Get a complete, runnable HTML/CSS/JS file with live preview and ZIP download.",
    feat_quotas_title: "Transparent Quotas",
    feat_quotas_desc:
      "Clear monthly limits per plan. No surprise overages. Upgrade or top-up only when you need to.",
    feat_secure_title: "EU-grade Privacy",
    feat_secure_desc:
      "Your data stays yours. Encrypted in transit and at rest. GDPR-friendly by design.",
    feat_multilang_title: "Tri-lingual UI",
    feat_multilang_desc:
      "Italian, English, Polish — auto-detected from the browser. No setup needed.",
    voice_pretitle: "New — voice input",
    voice_title: "Talk to NEURACOM. In your language.",
    voice_subtitle:
      "Tap the mic, dictate your prompt, and let OpenAI Whisper turn your voice into perfect text — automatically. No setup, no apps, no transcription tools.",
    voice_bullet_languages: "Auto-detects Italian, English and Polish — no manual selection needed",
    voice_bullet_fast: "Whisper-1 processes under 3 seconds for typical 30-second clips",
    voice_bullet_private: "Audio is processed transiently, never stored — fully GDPR-friendly",
    voice_cta_primary: "Try voice chat free",
    voice_cta_note: "No credit card required",
    voice_transcript_label: "Live transcript",
    voice_transcript_example: "“Write a one-paragraph product update email in a friendly tone.”",
    cta_title: "Ready to build with AI?",
    cta_subtitle:
      "Start free today. Upgrade only when you ship something real.",
    cta_button: "Create your account",
  },
  pricing: {
    title: "Simple, transparent pricing",
    subtitle: "Choose the plan that fits your usage. Cancel anytime.",
    per_month: "/month",
    most_popular: "MOST POPULAR",
    cta_free: "Start free",
    cta_paid: "Subscribe",
    current_plan: "Current plan",
    cycle_monthly: "Monthly",
    cycle_annual: "Annual",
    cycle_save_badge: "Save 2 months",
    annual_total: "€{total}/year — save €{saved} vs monthly",
    promo_first_month_note: "First month only — €{price}/month thereafter",
    promo_cleared_annual: "Promo codes apply only to monthly billing — annual plans already include the discount.",
    err_PROMO_NOT_VALID_FOR_ANNUAL: "Promo codes only apply to monthly billing. Switch to monthly to use a promo.",
    free_name: "Free",
    free_price: "€0",
    free_tagline: "Try the platform",
    starter_name: "Starter",
    starter_tagline: "For solo creators",
    pro_name: "Pro",
    pro_tagline: "For freelancers & small teams",
    business_name: "Business",
    business_tagline: "For agencies & companies",
    legal_specialized: "Specialized vertical",
    legal_pro_name: "Legal Pro",
    legal_pro_tagline: "For lawyers, consultants and DPOs. Specialized assistant for Italian & EU law, with priority access to the most powerful reasoning model.",
    legal_pro_target: "Designed for: lawyers, accountants, HR managers, DPOs, in-house counsel.",
    legal_pro_cta: "Upgrade to Legal Pro",
    legal_pro_feature_quota: "8,000 AI messages, 300 images, 100 code projects, 50 PDF Q&A per month",
    legal_pro_feature_opus: "Priority access to Claude Opus 4.8 & Fable 5 (beta) — 1M context for legal reasoning",
    legal_pro_feature_default_on: "Legal Mode active by default on every new chat",
    legal_pro_feature_templates: "7 pre-built legal templates (NDA, GDPR notice, consulting contracts, e-commerce T&C…)",
    legal_pro_feature_rag: "Automatic clause-by-clause analysis of uploaded contracts (PDF Q&A) + 103 curated rulings",
    legal_pro_feature_kb: "Personal Legal Knowledge Base with Auto-KB ambient citations",
    legal_pro_feature_priority: "Priority support & responses",
    feat_msgs: "{n} AI chat messages/month",
    feat_imgs: "{n} image generations/month",
    feat_code: "{n} code projects/month",
    feat_models: "Multi-model: Claude, GPT, Gemini",
    feat_priority: "Priority support",
    feat_email: "Email support",
    feat_history: "Full history retained",
    feat_api: "API access (Business only)",
    promo_label: "Have a promo code?",
    promo_placeholder: "LAUNCH2026",
    promo_apply: "Apply",
    promo_clear: "Clear",
    promo_applied: "✓ Promo applied — Pro first month at €{price}",
    promo_banner_title: "🚀 Launch promo — first month of Pro at €9",
    promo_banner_subtitle: "Use code {code}. Limited to the first 100 subscribers ({remaining} left).",
    err_PROMO_INVALID_CODE: "Invalid promo code.",
    err_PROMO_PLAN_MISMATCH: "This code is only valid for the Pro plan.",
    err_PROMO_EXHAUSTED: "Sorry — this promo is now sold out.",
  },
  auth: {
    welcome_back: "Welcome back",
    welcome_new: "Create your NEURACOM account",
    email_label: "Email",
    password_label: "Password",
    name_label: "Your name (optional)",
    sign_in_btn: "Sign in",
    sign_up_btn: "Create account",
    google_btn: "Continue with Google",
    have_account: "Already have an account?",
    no_account: "Don't have an account?",
    or_divider: "or",
    password_hint: "Min 8 characters",
    err_AUTH_INVALID_CREDENTIALS: "Invalid email or password.",
    err_AUTH_EMAIL_ALREADY_REGISTERED: "This email is already registered.",
    err_AUTH_EMERGENT_NO_EMAIL: "Google login failed — no email returned.",
    err_AUTH_EMERGENT_INVALID_SESSION: "Google login session expired.",
    err_AUTH_NOT_AUTHENTICATED: "Please sign in to continue.",
    err_AUTH_INVALID_TOKEN: "Your session has expired. Please sign in again.",
    err_UNKNOWN_ERROR: "An unknown error occurred. Please try again.",
  },
  dashboard: {
    welcome: "Welcome back",
    current_plan: "Current plan",
    usage_overview: "Usage this period",
    messages_used: "Chat messages",
    images_used: "Images generated",
    code_used: "Code projects",
    quick_actions: "Quick actions",
    action_chat: "Start a new chat",
    action_image: "Generate an image",
    action_code: "Build with AI",
    recent_chats: "Recent conversations",
    recent_images: "Recent images",
    no_activity: "No activity yet. Get started above.",
    upgrade_cta: "Upgrade to {plan} for more capacity",
    tier_free: "Free",
    tier_starter: "Starter",
    tier_pro: "Pro",
    tier_business: "Business",
  },
  chat: {
    new_chat: "New chat",
    conversations: "Conversations",
    placeholder: "Ask anything…",
    send: "Send",
    model: "Model",
    thinking: "Thinking…",
    model_claude: "Claude Sonnet 4.5",
    model_gpt: "GPT-5.2",
    model_gemini: "Gemini 3 Flash",
    group_claude: "Anthropic — Claude",
    group_openai: "OpenAI",
    group_gemini: "Google — Gemini",
    model_claude_sonnet: "Claude Sonnet 4.5 — Balanced",
    model_claude_sonnet_46: "Claude Sonnet 4.6 — Smartest balanced",
    model_claude_opus_48: "Claude Opus 4.8 — Flagship reasoning",
    model_claude_fable_5: "Claude Fable 5 — 1M context (beta)",
    model_fallback_toast: "{from} not yet routed — using {to} instead",
    model_claude_haiku: "Claude Haiku 4.5 — Fast",
    model_claude_opus: "Claude Opus 4.5 — Max reasoning",
    model_gpt_52: "GPT-5.2 — Latest",
    model_gpt_4o: "GPT-4o — Multimodal",
    model_gpt_41_mini: "GPT-4.1 Mini — Fast",
    model_gemini_flash: "Gemini 3 Flash — Fast",
    model_gemini_pro: "Gemini 3.1 Pro — Long context",
    mic_start: "Speak to NEURACOM",
    mic_stop: "Stop and transcribe",
    mic_transcribing: "Transcribing…",
    mic_denied: "Microphone permission denied. Allow access from your browser to dictate.",
    mic_unsupported: "Your browser doesn't support voice input.",
    mic_too_short: "Recording too short — hold a bit longer.",
    mic_no_speech: "No speech detected. Try again.",
    mic_no_device: "No microphone found on this device.",
    mic_failed: "Couldn't transcribe the audio. Try again.",
    err_STT_UNSUPPORTED_FORMAT: "Audio format not supported.",
    err_STT_FILE_TOO_LARGE: "Audio file too large (max 25 MB).",
    err_STT_PROVIDER_ERROR: "Voice transcription service error. Try again later.",
    err_STT_EMPTY_FILE: "Audio file is empty.",
    no_messages: "Start a conversation. Switch models anytime.",
    delete_confirm: "Delete this conversation?",
    smart_chips_title: "Quick start",
    smart_chips_hint: "Pick a task to route to the best AI brain — or just type.",
    smart_chip_write_title: "Write",
    smart_chip_write_desc: "Emails, posts, copy. Routed to GPT.",
    smart_chip_write_prompt: "Help me write a clear, persuasive email to ",
    smart_chip_code_title: "Code",
    smart_chip_code_desc: "Debug, refactor, explain. Routed to Claude.",
    smart_chip_code_prompt: "Help me with this code — explain what it does and how to improve it:\n\n```\n\n```",
    smart_chip_analyze_title: "Analyze",
    smart_chip_analyze_desc: "Reasoning, comparisons, decisions. Routed to Claude.",
    smart_chip_analyze_prompt: "Analyze the following and give me the pros, cons and a recommendation:\n\n",
    smart_chip_brainstorm_title: "Brainstorm",
    smart_chip_brainstorm_desc: "Ideas, names, angles. Routed to GPT.",
    smart_chip_brainstorm_prompt: "Brainstorm 10 creative ideas about ",
    smart_chip_image_title: "Describe an image",
    smart_chip_image_desc: "Multimodal understanding. Routed to Gemini.",
    smart_chip_image_prompt: "I'm going to describe an image (or paste a link). Help me write a detailed alt-text and a marketing caption: ",
    smart_chip_research_title: "Research",
    smart_chip_research_desc: "Sources, summaries, long docs. Routed to Gemini.",
    smart_chip_research_prompt: "Research and summarize the latest on ",
    brain_hint_code: "This looks like code — {brain} usually gives sharper answers for programming.",
    brain_hint_analyze: "This needs careful reasoning — {brain} excels at step-by-step analysis.",
    brain_hint_research: "Looks like a research task — {brain} handles long context and sources well.",
    brain_hint_creative: "This is a creative writing task — {brain} produces more natural copy.",
    brain_hint_switch: "Switch to {brain}",
    help_which_brain: "Which brain?",
    legal_mode_on: "Legal mode ON",
    legal_mode_off: "Legal mode",
    legal_mode_active: "Legal mode active — specialized IT/EU legal assistant",
    legal_mode_inactive: "Click to enable specialized legal advisor (IT/EU)",
    legal_short: "Legal",
    legal_disclaimer: "Legal mode active: specialized IT/EU jurisdiction assistant. Responses are informational and do NOT replace a qualified lawyer or DPO.",
    kb_context_title: "Active KB context · {count}",
    kb_context_clear: "Clear all",
    kb_context_hint: "These notes from your Personal KB will be sent as grounding context for your next message.",
    kb_suggest_title: "Suggested from your KB",
    kb_suggest_include: "Include",
    kb_suggest_dismiss: "Dismiss",
    kb_suggest_added: "Note added to chat context",
    auto_include_on: "Auto-KB",
    auto_include_off: "Auto-KB",
    auto_short: "AI",
    auto_include_active: "Auto-include ON — server picks top-3 KB notes for every message",
    auto_include_inactive: "Auto-include OFF — click to enable zero-click KB context",
    auto_include_banner: "Auto-KB is ON — top-3 of your notes will be injected into your next message automatically.",
    legal_templates_title: "Templates:",
    legal_templates: {
      consulting_label: "Consulting agreement",
      consulting_prompt: "Draft a professional consulting agreement between an Italian Srl (committente) and a freelance consultant (consulente) for IT advisory services. Include: parties, scope, duration 12 months with auto-renewal, fee (€X/hour + monthly cap), confidentiality clause, IP assignment of deliverables, GDPR processor clause (art. 28), termination for cause, jurisdiction Italy.",
      nda_label: "NDA / Confidentiality",
      nda_prompt: "Draft a mutual NDA (bilateral) under Italian law between two Srl companies for a business discussion phase. Include: definition of 'Confidential Information', exclusions, 5-year duration, return/destruction obligation, penalty €50,000 per breach, exclusive jurisdiction Milan, plus a GDPR Art. 28 reference if personal data may be exchanged.",
      privacy_gdpr_label: "GDPR privacy notice (art. 13)",
      privacy_gdpr_prompt: "Draft an Art. 13 GDPR privacy notice for a B2C e-commerce website. Cover: identity of controller, contact of DPO (if appointed), categories of data, legal bases (art. 6 GDPR), recipients, retention periods, third-country transfers (art. 44 ss.), data-subject rights (art. 15-22), right to lodge complaint with Garante Privacy, profiling/automated decision-making per art. 22.",
      ecommerce_tc_label: "E-commerce T&C (B2C)",
      ecommerce_tc_prompt: "Draft B2C terms & conditions for an Italian e-commerce website selling consumer electronics. Include: parties, order acceptance, price/VAT, payment, shipping/delivery, statutory withdrawal right (art. 52 Codice del Consumo, 14 days), legal warranty (art. 130-135 Codice del Consumo, 24 months), liability limits, ODR/online dispute resolution platform link, jurisdiction at consumer's residence per art. 33 D.Lgs. 206/2005.",
      diffida_label: "Formal demand letter",
      diffida_prompt: "Draft a formal demand letter (lettera di diffida ad adempiere ex art. 1454 c.c.) to an Italian Srl that has failed to pay an invoice of €X within the due date. Grant 15 days to perform, mention the contract reference, calculation of legal interest ex D.Lgs. 231/2002 for B2B late payments, and warn that on expiry the contract will be considered resolved ipso iure and judicial action will follow.",
      disdetta_locazione_label: "Lease termination",
      disdetta_locazione_prompt: "Draft a tenant's lease termination notice (disdetta) for a 4+4 residential lease under L. 431/1998 in Italy, providing the legally required 6-month notice. Include the property address, contract registration data, requested termination date, optionally cite 'gravi motivi' ex art. 3 L. 431/1998 if relevant, and request a final meter reading meeting.",
      disciplinare_label: "Disciplinary notice (Art. 7 St. Lav.)",
      disciplinare_prompt: "Draft a disciplinary contestation letter to an employee under Art. 7 L. 300/1970 (Statuto dei Lavoratori) and the applicable CCNL. State the specific facts in detail (date, time, place, witnesses), the contractual clauses allegedly violated, grant the 5-day window for written justifications, and remind the employee of the right to be heard with union representation.",
    },
    err_QUOTA_MESSAGES_EXCEEDED: "Monthly message limit reached. Upgrade your plan to continue.",
    err_LLM_PROVIDER_ERROR: "AI provider error. Try a different model.",
  },
  brains: {
    back: "← Back to chat",
    pretitle: "AI Models · How to choose",
    title: "Three brains. One subscription.",
    subtitle: "Each model has a different personality. Pick the one that fits your task — or let NEURACOM recommend one for you automatically.",
    strengths: "Strengths",
    try_example: "Try this example",
    pick_btn: "Use this brain now",
    col_dimension: "Dimension",
    row_best_for: "Best for",
    row_speed: "Speed",
    row_context: "Context window",
    row_languages: "Languages",
    row_style: "Style",
    claude: {
      tagline: "The careful reasoner",
      strength_1: "Writing and explaining code with surgical precision",
      strength_2: "Long-form reasoning, contracts, legal analysis",
      strength_3: "Refusing politely when something is off — fewer hallucinations",
      strength_4: "Step-by-step explanations that hold up under scrutiny",
      example: "Review this Python function for bugs and tell me how you'd refactor it for clarity.",
      best_for: "Code, contracts, reasoning",
      speed: "Medium",
      context: "200K tokens",
      languages: "Excellent IT/EN/PL",
      style: "Thoughtful, structured",
    },
    gpt: {
      tagline: "The natural writer",
      strength_1: "Marketing copy, emails and posts that sound human",
      strength_2: "Brainstorming many alternatives quickly",
      strength_3: "General-purpose assistant — broad knowledge",
      strength_4: "Friendly conversational tone out of the box",
      example: "Write 5 different subject-line variants for a launch email about our new AI platform.",
      best_for: "Writing, brainstorming, general",
      speed: "Fast",
      context: "128K tokens",
      languages: "Excellent IT/EN/PL",
      style: "Natural, friendly",
    },
    gemini: {
      tagline: "The multimodal researcher",
      strength_1: "Understanding images and visual content",
      strength_2: "Processing huge documents and finding the needle",
      strength_3: "Up-to-date world knowledge and research synthesis",
      strength_4: "Strong with structured data, tables, spreadsheets",
      example: "Summarize the key findings of this 80-page PDF and quote the most important paragraph.",
      best_for: "Multimodal, long research",
      speed: "Fast",
      context: "2M tokens",
      languages: "Excellent IT/EN/PL",
      style: "Factual, comprehensive",
    },
    reassure_switch_title: "Switch any time",
    reassure_switch_desc: "Change brain mid-conversation. We carry the context.",
    reassure_auto_title: "Smart auto-routing",
    reassure_auto_desc: "Type freely — we'll hint when a different brain would be sharper.",
    reassure_lang_title: "All three fluent",
    reassure_lang_desc: "Italian, English and Polish — same quality across models.",
  },
  team: {
    nav_label: "Team",
    title: "Team",
    pretitle: "Magic Inbox",
    members_count: "members",
    upsell_pretitle: "Team workspace · Business plan",
    upsell_title: "Bring your team into NEURACOM.",
    upsell_subtitle: "Magic Inbox is included with the Business plan.",
    upsell_card_title: "Magic Inbox — shared team workspace",
    upsell_card_desc: "Invite up to 5 teammates, see what they're working on, and turn NEURACOM into your team's AI layer.",
    upsell_feat_1: "Up to 5 seats — invite by email",
    upsell_feat_2: "Shared activity feed of what the team is doing",
    upsell_feat_3: "Single Business subscription covers everyone",
    upsell_cta: "Upgrade to Business",
    create_title: "Create your team",
    create_subtitle: "You're on Business — set up your team in 10 seconds.",
    field_name: "Team name",
    field_name_placeholder: "Acme Marketing",
    create_btn: "Create team",
    created: "Team created.",
    create_failed: "Could not create the team. Try again.",
    members_title: "Members & invites",
    invite_placeholder: "teammate@company.com",
    invite_btn: "Invite",
    invited: "Invite sent.",
    invite_failed: "Could not send invite.",
    invite_pending: "Invite pending",
    invite_revoked: "Invite revoked.",
    role_owner: "Owner",
    role_member: "Member",
    remove_confirm: "Remove this member from the team?",
    removed: "Member removed.",
    leave_btn: "Leave team",
    leave_confirm: "Are you sure you want to leave this team?",
    left: "You left the team.",
    delete_btn: "Delete team",
    delete_confirm: "Permanently delete this team? All members will lose access.",
    deleted: "Team deleted.",
    danger_title: "Danger zone",
    danger_desc: "Deleting the team unassigns all members. It does not delete their accounts or content.",
    full: "Team is at capacity. Remove someone before inviting again.",
    feed_title: "Team activity",
    feed_desc: "Live feed of important events across all team members.",
    feed_empty: "No team activity yet. As soon as members start using NEURACOM, you'll see it here.",
    accept_loading: "Joining team…",
    accept_success_title: "You're in!",
    accept_success_desc: "Welcome to the {name} team.",
    accept_continue: "Open team workspace",
    accept_error_title: "Couldn't accept invite",
    accept_error_generic: "This invite is invalid or has expired.",
    accept_go_dashboard: "Go to dashboard",
    err_TEAM_INVITE_INVALID: "This invite link is invalid or has been revoked.",
    err_TEAM_INVITE_EXPIRED: "This invite has expired. Ask the owner to send a new one.",
    err_TEAM_INVITE_EMAIL_MISMATCH: "This invite is for a different email address.",
    err_TEAM_ALREADY_MEMBER: "You're already in a team.",
    err_TEAM_LIMIT_REACHED: "The team has reached its member limit.",
    err_TEAM_REQUIRES_BUSINESS: "Upgrade to the Business plan to create a team.",
    err_TEAM_INVITE_SELF: "You can't invite yourself.",
    err_TEAM_INVITE_DUPLICATE: "An invite is already pending for that email.",
    err_TEAM_INVITE_ALREADY_IN_TEAM: "That user is already in a team.",
    err_TEAM_NOT_OWNER: "Only the team owner can do that.",
    err_TEAM_OWNER_CANNOT_LEAVE: "Owners can't leave — delete the team instead.",
  },
  images: {
    title: "Image Studio",
    prompt_label: "Describe the image you want to create",
    prompt_label_edit: "Describe how to transform the reference image",
    prompt_placeholder: "A futuristic city skyline at sunset, cinematic lighting...",
    prompt_placeholder_edit: "Turn this into a watercolor painting / put it on Mars / give it neon lights…",
    provider_label: "Provider",
    provider_gemini: "Gemini Nano Banana",
    provider_openai: "OpenAI GPT-Image-1",
    generate_btn: "Generate image",
    edit_btn: "Edit with reference",
    edit_badge: "Edit",
    edit_success: "Image edited",
    gen_success: "Image generated",
    generating: "Generating… this can take up to 60 seconds.",
    gallery: "Your gallery",
    no_images: "No images yet. Generate your first above.",
    download: "Download",
    reference_label: "Reference image (optional, for image-to-image)",
    reference_pick: "Click to upload PNG / JPG / WEBP",
    reference_size_hint: "Max 8 MB",
    reference_active: "Reference active",
    reference_hint: "Your next generation will transform this image based on your prompt.",
    reference_forced_gemini: "Reference images are only supported by Gemini Nano Banana. Provider switched.",
    no_reference_support: "No reference",
    err_QUOTA_IMAGES_EXCEEDED: "Monthly image limit reached. Upgrade your plan to continue.",
    err_IMAGE_PROVIDER_ERROR: "Image provider error. Try the other provider.",
    err_IMAGE_REFERENCE_INVALID_BASE64: "Couldn't read the reference image. Try a different file.",
    err_IMAGE_REFERENCE_TOO_LARGE: "Reference image is too large (max 8 MB).",
    err_REFERENCE_INVALID_TYPE: "Unsupported file type — use PNG, JPG or WEBP.",
  },
  code: {
    title: "AI Code Builder",
    subtitle: "Describe a web app or page. Get a complete runnable HTML file.",
    subtitle_multi: "Describe a web app. Get a complete multi-file project — preview, edit, download as ZIP.",
    prompt_label: "What should we build?",
    prompt_placeholder: "A landing page for a coffee shop with menu, gallery, and contact form…",
    generate_btn: "Generate project",
    generating: "Building… this can take 30-90 seconds.",
    preview: "Preview",
    code: "Code",
    download_html: "Download .html",
    download_file: "Download file",
    download_zip: "Download ZIP",
    copy_code: "Copy code",
    copy_file: "Copy file",
    copied: "Copied!",
    files_label: "{count} files",
    no_files: "No files in this project.",
    projects: "Your projects",
    no_projects: "No projects yet. Describe your first idea above.",
    generated_success: "Project generated",
    err_QUOTA_CODE_EXCEEDED: "Monthly code generation limit reached. Upgrade your plan to continue.",
    err_CODE_GEN_EMPTY: "The model didn't return valid code. Try rephrasing your prompt.",
  },
  billing: {
    title: "Billing & subscription",
    current_plan: "Current plan",
    renewal: "Renews on",
    no_renewal: "No active subscription",
    change_plan: "Change plan",
    history: "Payment history",
    no_history: "No transactions yet.",
    paid: "Paid",
    pending: "Pending",
    failed: "Failed",
  },
  payment: {
    processing: "Processing your payment…",
    success_title: "Payment successful!",
    success_subtitle: "Your subscription is now active.",
    go_dashboard: "Go to dashboard",
    cancelled_title: "Payment cancelled",
    cancelled_subtitle: "No charge was made.",
    back_pricing: "Back to pricing",
  },
  footer: {
    tagline: "AI Platform powered by TelcaVoIP",
    product: "Product",
    legal: "Legal",
    terms: "Terms",
    privacy: "Privacy",
    cookies: "Cookies",
    privacy_center: "Privacy Center",
    contact_us: "Contact",
    contact: "Contact",
    copyright: "© 2026 TelcaVoIP International EU — All rights reserved",
  },
  documents: {
    title: "Documents",
    subtitle: "Upload a PDF and chat with it. Ask questions, get summaries — powered by Claude.",
    upload_btn: "Upload PDF",
    upload_hint: "Drop a PDF here or click to browse (max 10 MB)",
    uploading: "Uploading & extracting text…",
    list_title: "Your documents",
    no_documents: "No documents yet. Upload your first PDF above.",
    pages: "pages",
    chars: "chars",
    ask_placeholder: "Ask anything about this document…",
    thinking: "Reading the document…",
    open: "Open",
    err_DOC_INVALID_FORMAT: "Only PDF files are supported.",
    err_DOC_TOO_LARGE: "File is too large (max 10 MB).",
    err_DOC_PARSE_ERROR: "Couldn't read this PDF.",
    err_DOC_NO_TEXT_EXTRACTED: "This PDF doesn't contain selectable text (scanned image?).",
    err_QUOTA_DOCUMENTS_EXCEEDED: "Monthly document limit reached. Upgrade your plan.",
    err_QUOTA_MESSAGES_EXCEEDED: "Monthly message limit reached. Upgrade your plan.",
    truncated_warning: "⚠️ This document is large ({chars} characters). Only the first 50,000 characters are used for answering questions. Consider splitting the PDF into smaller files for full coverage.",
    legal_mode_on: "Legal mode ON",
    legal_mode_off: "Legal analysis",
    legal_mode_on_hint: "Specialized clause-by-clause analysis active",
    legal_mode_off_hint: "Click for clause-by-clause analysis (IT/EU law)",
    legal_mode_banner: "Legal mode active: this document will be analyzed clause-by-clause, citing specific provisions of Codice Civile, Codice del Consumo and GDPR, and flagging unfair / abusive clauses (ex art. 1341/1342 c.c., art. 33 Codice del Consumo).",
    upload_success: "Document uploaded",
    legal_detected_title: "📜 Legal document detected",
    legal_detected_desc: "We spotted legal terminology (articles, clauses, GDPR, jurisdiction). Enable Legal Mode for specialized clause-by-clause analysis with citations to Italian / EU law.",
    legal_detected_cta: "Enable Legal Mode",
  },
  referrals: {
    title: "Invite colleagues, earn cash",
    subtitle: "Share your link. When a colleague subscribes to Legal Pro or Business, you earn €20 + 1 free month of Pro + 5% commission on every marketplace template they sell for the next 12 months.",
    your_code: "Your code",
    your_link: "Your referral link",
    copy: "Copy",
    copied: "Copied!",
    stats_invited: "Invited",
    stats_paying: "Rewarded",
    stats_bonus: "Bonus months earned",
    stats_credit_balance: "Credit balance",
    stats_credit_lifetime: "Lifetime earned",
    program_title: "How NEURACOM Affiliate works",
    program_step1: "Share your unique link with colleagues",
    program_step2: "They subscribe to Legal Pro or Business",
    program_step3: "You earn €{credit} + 1 free month of Pro",
    program_step4: "Plus 5% commission on their marketplace sales for 12 months",
    payout_hint: "Credits roll into your marketplace payout (threshold €50). Go to {sales} to cash out.",
    payout_hint_link: "My sales",
    commissions_title: "Recent commissions from referred users",
    commissions_empty: "No commissions yet. When a referred user sells a marketplace template, your 5% lands here.",
    commissions_col_buyer: "Buyer",
    commissions_col_price: "Sale price",
    commissions_col_commission: "Your 5%",
    commissions_col_date: "Date",
    table_title: "People you invited",
    no_invites: "No invites yet. Share your link to get started.",
    col_user: "User",
    col_tier: "Plan",
    col_status: "Status",
    col_date: "Joined",
    col_eligible: "Commission window",
    status_rewarded: "Rewarded",
    status_pending: "Pending paid sub",
    until: "until {date}",
    err_REF_INVALID_CODE: "Invalid referral code.",
    err_REF_SELF_REFERRAL: "You can't refer yourself.",
    err_REF_ALREADY_REFERRED: "You already have a referrer.",
    err_REF_NOT_ELIGIBLE_PAID_USER: "Only free-tier users can apply a referral code.",
  },
  billing_v2: {
    cancel_subscription: "Cancel subscription",
    reactivate: "Reactivate subscription",
    confirm_cancel: "Are you sure? You'll keep access until the end of the period, then downgrade to Free.",
    cancelling_banner: "Your subscription will end on {date}. You can reactivate anytime before then.",
    expiring_soon: "Your subscription renews on {date}. Renew manually before that date to keep your plan.",
    manual_renewal_note: "ℹ️ Currently subscriptions are monthly, paid manually. We'll notify you before expiration.",
  },
  legal: {
    terms_title: "Terms of Service",
    terms_intro: "These terms govern your use of NEURACOM by TelcaVoIP. Please read carefully.",
    terms_last_updated: "Last updated: February 2026",
    privacy_title: "Privacy Policy",
    privacy_intro: "We respect your privacy. This page explains what data we collect and how we use it.",
    privacy_last_updated: "Last updated: February 2026",
    back_home: "← Back to home",
  },
  cookies: {
    banner_aria: "Cookie consent",
    banner_title: "We respect your privacy.",
    banner_text: "We only use essential cookies to keep you signed in and remember your preferences. No tracking, no advertising.",
    banner_learn_more: "Learn more",
    accept_all: "Got it",
    reject_all: "Essential only",
    pill_label: "Cookies",
    pill_aria: "Open cookie preferences",
  },
  privacy_center: {
    pretitle: "GDPR · Privacy Rights",
    title: "Privacy Center",
    subtitle: "A single place to exercise your data-protection rights — whether you're a current user, an ex-user or never had an account. We respond within 30 days as required by GDPR Art. 12.",
    dpo_title: "Data Protection Officer",
    dpo_desc: "Direct contact for any privacy question, request or concern.",
    controller_title: "Data Controller",
    controller_desc: "The legal entity responsible for the processing of your personal data.",
    docs_title: "Policy documents",
    link_privacy: "Privacy Policy",
    link_cookies: "Cookie Policy",
    link_terms: "Terms of Service",
    form_title: "Submit a data request",
    form_desc: "Use this form if you don't have (or no longer have) an account. Registered users can also exercise these rights directly from Settings.",
    field_email: "Your email",
    field_type: "Request type",
    field_message: "Message",
    field_message_placeholder: "Please describe your request. Include any context that helps us identify your data (e.g. former email, approximate signup date).",
    type_access: "Access my data (Art. 15)",
    type_portability: "Data portability (Art. 20)",
    type_rectification: "Rectification (Art. 16)",
    type_erasure: "Erasure / right to be forgotten (Art. 17)",
    type_objection: "Object to processing (Art. 21)",
    type_other: "Other / general inquiry",
    deadline_note: "We reply within 30 days (GDPR Art. 12).",
    submit_btn: "Send request",
    submit_success: "Request received.",
    submit_failed: "Could not submit. Please try again or email privacy@telcavoip.eu directly.",
    success_title: "Request received",
    success_desc: "Thanks. We've sent a confirmation to our Data Protection Officer and you'll hear back within 30 days. For urgent matters, email privacy@telcavoip.eu.",
    authorities_title: "Supervisory authorities",
    authorities_desc: "If you believe your rights have been infringed, you can lodge a complaint with the data-protection authority in your country of residence or work.",
  },
  settings: {
    title: "Settings",
    pretitle: "Account",
    subtitle: "Manage your profile, privacy and GDPR data rights.",
    profile_title: "Profile",
    profile_desc: "Your account details.",
    email: "Email",
    name: "Name",
    plan: "Plan",
    locale: "Language",
    cookies_title: "Cookie preferences",
    cookies_desc: "Review or reset the consent you gave for non-essential cookies.",
    cookies_reset_btn: "Reset cookie consent",
    cookies_reset_success: "Cookie consent cleared. The banner will reappear.",
    export_title: "Download your data",
    export_desc: "GDPR Art. 20 — get a complete JSON export of every piece of personal data we hold about you.",
    export_btn: "Export my data (JSON)",
    export_success: "Export downloaded.",
    export_failed: "Could not generate export. Try again.",
    rights_title: "Your GDPR rights",
    rights_desc: "Under EU regulation 2016/679 you have the following rights, exercisable at any time:",
    right_access: "Right of access (Art. 15)",
    right_portability: "Right to data portability (Art. 20)",
    right_erasure: "Right to erasure / to be forgotten (Art. 17)",
    right_rectification: "Right of rectification (Art. 16)",
    right_object: "Right to object & restrict processing (Art. 21–22)",
    edit_profile_btn: "Edit profile",
    edit_title: "Edit profile",
    edit_desc: "Update your name or change your password. Email is locked — contact support to change it.",
    change_password: "Change password",
    change_password_hint: "Leave blank if you don't want to change the password.",
    current_password: "Current password",
    new_password: "New password (min 8 chars)",
    edit_save_btn: "Save changes",
    edit_success: "Profile updated.",
    edit_failed: "Couldn't update profile. Try again.",
    edit_invalid_password: "Current password is incorrect.",
    edit_password_too_short: "New password must be at least 8 characters.",
    edit_current_password_required: "Enter your current password to set a new one.",
    edit_nothing_to_update: "Change something before saving.",
    danger_title: "Delete account",
    danger_desc: "Irreversibly erases your account, chats, images, code projects, documents, partner commissions and activity events. Payment records are pseudonymised but kept for accounting compliance.",
    delete_btn: "Delete my account",
    delete_confirm_title: "Confirm account deletion",
    delete_confirm_desc: "To confirm, type your email address ({email}) below. This action cannot be undone.",
    delete_confirm_btn: "Permanently delete",
    delete_email_mismatch: "Email doesn't match.",
    delete_success: "Account deleted. We're sorry to see you go.",
    delete_failed: "Could not delete account. Contact support.",
  },
  affiliate_page: {
    hero_pretitle: "Partner Program",
    hero_title: "Resell NEURACOM. Earn 20% recurring.",
    hero_subtitle: "Help businesses adopt AI and earn a 20% commission on every subscription you bring — for as long as they stay.",
    cta_apply: "Apply to become a partner",
    cta_dashboard: "Open partner dashboard",
    benefit_commission_title: "20% commission, every month",
    benefit_commission_desc: "Get 20% on every paid subscription you refer (Starter, Pro, Business). Paid monthly, no caps.",
    benefit_tools_title: "Marketing toolkit",
    benefit_tools_desc: "Branded link, dashboard with stats, and email templates to close deals faster.",
    benefit_priority_title: "Priority support",
    benefit_priority_desc: "Direct line to our team. We help you onboard your first clients.",
    how_title: "How it works",
    how_step1_title: "1. Apply",
    how_step1_desc: "Submit your application. We review within 48h.",
    how_step2_title: "2. Share your link",
    how_step2_desc: "Once approved, share your unique link with leads.",
    how_step3_title: "3. Earn",
    how_step3_desc: "Get 20% commission on every paid subscription. Request payout anytime.",
    form_title: "Become a NEURACOM partner",
    form_company: "Company name (optional)",
    form_website: "Website (optional)",
    form_volume: "Expected monthly referrals",
    form_pitch: "Tell us about your audience",
    form_submit: "Submit application",
    status_pending_title: "Application pending",
    status_pending_desc: "Thanks! Our team will review within 48 hours. You'll receive an email when approved.",
    status_approved_title: "You're a partner!",
    status_approved_desc: "Open your dashboard to grab your link and start earning.",
    status_rejected_title: "Application rejected",
    status_rejected_desc: "Unfortunately we cannot approve your application at this time. Contact us for details.",
    err_AFFILIATE_ALREADY_APPLIED: "You've already applied or are already a partner.",
    application_submitted: "Application submitted!",
  },
  jurisprudence: {
    hero_pretitle: "NEURACOM Legal Database",
    title: "Italian & EU Jurisprudence",
    title_nav: "Jurisprudence",
    subtitle: "Search a curated corpus of {count} landmark rulings from Cassazione, Constitutional Court, CJEU and the Garante Privacy. Cited automatically by Legal Mode when relevant.",
    search_placeholder: "e.g. 'unfair clauses', 'GDPR consent', 'art. 1341 c.c.'…",
    search_btn: "Search",
    filter_by_topic: "Filter by topic",
    empty_title: "Search a legal principle, a topic, or an article number",
    empty_desc: "Or pick a topic chip above to start browsing.",
    no_results: "No rulings match your search. Try a different keyword or remove the topic filter.",
    disclaimer_title: "Note:",
    disclaimer_body: "This is a hand-curated educational corpus, NOT a substitute for paid databases like Italgiure, De Jure or Westlaw. Always verify citations on official sources before relying on them in court.",
    topics: {
      diritto_civile: "Civil law",
      contratti: "Contracts",
      nullita: "Nullity",
      consumatori: "Consumer protection",
      clausole_vessatorie: "Unfair clauses",
      B2C: "B2C",
      UE: "EU law",
      GDPR: "GDPR",
      privacy: "Privacy",
      consenso: "Consent",
      trasferimenti_extra_UE: "Extra-EU transfers",
      marketing: "Marketing",
      newsletter: "Newsletter",
      lavoro: "Labor law",
      licenziamento: "Dismissal",
      art_18: "Art. 18 St. Lav.",
      disciplinare: "Disciplinary",
      art_7_st_lav: "Art. 7 St. Lav.",
      mobbing: "Mobbing",
      danno: "Damages",
      gig_economy: "Gig economy",
      riders: "Riders",
      locazione: "Lease",
      registrazione: "Registration",
      disdetta: "Termination",
      gravi_motivi: "Serious reasons",
      e_commerce: "E-commerce",
      informativa: "Disclosure",
      garanzia_legale: "Legal warranty",
      penale: "Criminal law",
      diffamazione: "Defamation",
      internet: "Internet",
      "231_2001": "D.Lgs. 231/2001",
      compliance: "Compliance",
      cyber: "Cyber",
      accesso_abusivo: "Unauthorized access",
      tributario: "Tax",
      abuso_diritto: "Abuse of right",
      art_10_bis: "Art. 10-bis",
      societario: "Corporate",
      azione_responsabilita: "Liability action",
      amministratori: "Directors",
      famiglia: "Family",
      assegno_divorzile: "Divorce maintenance",
      costituzionale: "Constitutional",
      fine_vita: "End of life",
      suicidio_assistito: "Assisted suicide",
      doppia_pregiudizialita: "Double preliminary ref.",
      proprieta_intellettuale: "Intellectual property",
      marchi: "Trademarks",
      registrazione_malafede: "Bad-faith registration",
      diritto_autore: "Copyright",
      sampling: "Sampling",
      procedura_civile: "Civil procedure",
      mediazione: "Mediation",
      condizione_procedibilita: "Procedural condition",
      bancario: "Banking",
      usura: "Usury",
      tasso_soglia: "Threshold rate",
      anatocismo: "Anatocism",
      interessi: "Interest",
      AI_act: "AI Act",
      intelligenza_artificiale: "AI",
      intermediazione_finanziaria: "Financial intermediation",
      responsabilita_medica: "Medical liability",
      foro_competente: "Jurisdiction",
      antitrust: "Antitrust",
      intese_anticoncorrenziali: "Anti-competitive agreements",
      successioni: "Successions",
      legittimari: "Forced heirs",
      azione_riduzione: "Reduction action",
      smart_working: "Smart working",
      diritto_disconnessione: "Right to disconnect",
      ferie: "Vacation rights",
      somministrazione: "Staff supply",
      dimissioni: "Resignation",
      maternita: "Maternity",
      fideiussione: "Guaranty",
      phishing: "Phishing",
      frodi_online: "Online fraud",
      mutuo: "Mortgage",
      estinzione_anticipata: "Early repayment",
      assicurazioni: "Insurance",
      RC_auto: "Motor liability",
      claims_made: "Claims-made",
      condominio: "Condominium",
      amministrativo: "Administrative law",
      appalti: "Public procurement",
      immigrazione: "Immigration",
      protezione_internazionale: "International protection",
      telecomunicazioni: "Telecommunications",
      videosorveglianza: "Video surveillance",
      smart_home: "Smart home",
      social_network: "Social networks",
      responsabilita_piattaforme: "Platform liability",
      diritto_oblio: "Right to be forgotten",
      decisioni_automatizzate: "Automated decisions",
      scoring: "Credit scoring",
      tech_giants: "Big Tech",
      revenge_porn: "Revenge porn",
      stalking: "Stalking",
      riciclaggio: "Money laundering",
      sicurezza_lavoro: "Workplace safety",
      infortunio: "Workplace injury",
      covid: "COVID-19",
      crisi_impresa: "Insolvency",
      greenwashing: "Greenwashing",
      pratiche_scorrette: "Unfair practices",
      ambiente: "Environment",
      energia: "Energy",
      fonti_rinnovabili: "Renewables",
      sport: "Sports law",
      trasporti: "Transport",
      turismo: "Tourism",
      usucapione: "Adverse possession",
      immissioni: "Nuisance",
      testamento: "Will",
      gestazione_terzi: "Surrogacy",
      affidamento_condiviso: "Joint custody",
      alienazione_parentale: "Parental alienation",
      convivenza: "De facto union",
      riforma_cartabia: "Cartabia reform",
      notifica: "Service of process",
      PEC: "Certified email",
      accertamento: "Tax assessment",
      iva: "VAT",
      false_comunicazioni_sociali: "False financial statements",
    },
    save_to_kb: "Save to my KB",
    kb_saved: "Saved to your Knowledge Base",
    kb_save_failed: "Could not save — please retry",
  },
  legal_kb: {
    title: "Personal Legal Knowledge Base",
    title_nav: "Legal KB",
    pretitle: "Legal Pro · Private database",
    subtitle: "{count} private notes — pin rulings, save chat answers, capture your own legal know-how. Stays inside your account.",
    new_note: "New note",
    new_title: "New note",
    edit_title: "Edit note",
    search_placeholder: "Search title, body, citation…",
    search_btn: "Search",
    filter_by_tag: "Filter by tag",
    clear_tag: "Clear tag",
    empty_title: "Your Knowledge Base is empty",
    empty_desc: "Save jurisprudence rulings, copy chat answers, or write your own notes here. Everything is private to your account.",
    source_all: "All",
    source_jurisprudence: "Rulings",
    source_chat: "Chat",
    source_document: "Documents",
    source_manual: "Manual",
    pin: "Pin to top",
    unpin: "Unpin",
    edit: "Edit",
    delete: "Delete",
    confirm_delete: "Delete this note? This cannot be undone.",
    toast_created: "Note saved to your Knowledge Base",
    toast_updated: "Note updated",
    toast_deleted: "Note deleted",
    err_load: "Could not load notes",
    err_save: "Could not save note",
    err_delete: "Could not delete note",
    err_required: "Title and content are required",
    err_LEGAL_KB_TIER_REQUIRED: "Personal Knowledge Base is available on Legal Pro and Business plans.",
    err_LEGAL_KB_NOTE_NOT_FOUND: "This note no longer exists.",
    field_title: "Title",
    field_title_ph: "e.g. Unfair clauses in B2C contracts",
    field_citation: "Citation (optional)",
    field_citation_ph: "e.g. Cass. civ. Sez. III n. 8268/2008",
    field_body: "Content",
    field_body_ph: "Write your note, paste an AI answer, or describe a legal principle…",
    field_tags: "Tags",
    field_tags_ph: "contracts, B2C, gdpr",
    field_tags_hint: "Comma-separated. Max 20 tags.",
    save_changes: "Save changes",
    save_note: "Save note",
    disclaimer: "Notes saved here are private to your NEURACOM account. They are NOT a substitute for an attorney's advice — verify citations on official sources (Italgiure, De Jure, EUR-Lex).",
    upsell_title: "Available on Legal Pro & Business",
    upsell_body: "Build your own private legal knowledge base inside NEURACOM. Save rulings, AI answers, and personal notes — all searchable, tagged, and encrypted at rest.",
    upsell_bullet1: "Save any jurisprudence ruling with one click",
    upsell_bullet2: "Capture AI chat answers as reusable maxims",
    upsell_bullet3: "Tag, search, and pin — your private corpus grows with you",
    upsell_cta: "Upgrade to Legal Pro",
    save_chat_btn: "Save to KB",
    save_chat_title: "Save AI answer",
    save_chat_hint: "Add a title and citation, then save this answer to your private Knowledge Base.",
    use_in_chat: "Use in chat",
    use_in_chat_added: "Note added as context for your next chat",
    use_in_chat_already: "This note is already in your chat context",
    use_in_chat_max: "Maximum {max} notes per chat — remove one first",
  },
  fable5: {
    banner_title: "Notify me about Claude Fable 5",
    banner_body: "Be the first to know when Fable 5 (1M context window) becomes natively available on NEURACOM Legal Pro. We'll send you a single notification email.",
    join_cta: "Notify me",
    leave: "Unsubscribe",
    subscribed: "You're on the waitlist",
    toast_joined: "You'll be notified when Fable 5 is available",
    toast_join_failed: "Could not join the waitlist — please retry",
    toast_left: "Removed from waitlist",
    toast_leave_failed: "Could not unsubscribe — please retry",
  },
  comparison: {
    pretitle: "Side-by-side · Why a vertical legal AI matters",
    title: "Generic ChatGPT vs. NEURACOM Legal Pro",
    subtitle: "Same monthly budget, radically different output. The detail of citations and the privacy framework are where lawyers, DPOs and tax accountants lose hours every week with generic AI.",
    col_feature: "Feature",
    col_generic: "Generic AI",
    col_neuracom: "NEURACOM Legal Pro",
    generic_subtitle: "ChatGPT Plus / equiv.",
    neuracom_subtitle: "Vertical legal AI",
    cat_citations: "Citations & legal research",
    cat_privacy: "Privacy & compliance",
    cat_workflow: "Legal workflow",
    cat_cost: "Cost & ROI",
    row_jurisprudence: "Database of 103 curated Italian Cassazione + EU rulings",
    row_kb: "Personal Legal Knowledge Base (private, encrypted)",
    row_auto_cite: "Auto-cite & ambient KB suggestions while you type",
    row_hallucinations: "Verbatim, hallucination-resistant citations",
    row_eu_hosted: "EU-hosted infrastructure",
    row_gdpr: "100% GDPR-compliant by design",
    row_no_training: "Your data is never used to train external models",
    row_templates: "7 pre-built Italian legal templates (NDA, GDPR, contracts…)",
    row_legal_register: "Formal Italian legal register out of the box",
    row_doc_analysis: "Clause-by-clause PDF contract analysis",
    row_price: "Monthly subscription",
    row_value: "Time saved on legal research (~10h/mo)",
    roi_headline: "Time payback: ~3 days/month at €60/h hourly rate.",
    roi_body: "An Italian solo practitioner at €60/h saves about 10 hours/month in jurisprudence research with NEURACOM Legal Pro. That's €600 of recovered billable time — for a €149/month subscription. The math is brutal.",
  },
  atti: {
    title_nav: "Atto Generator",
    pretitle: "Legal Pro · Killer feature",
    title: "Generate complete legal acts in 60 seconds",
    subtitle: "Pick the act type, fill 3 fields, get back a fully-formatted Italian legal document — formal register, numbered sections, with citations from your Personal KB auto-injected by Claude Opus 4.8.",
    sections_count: "sections",
    start: "Start",
    back: "Back",
    form_hint: "Required sections: {sections}",
    field_parties: "Parties involved",
    field_parties_ph: "e.g. Mario Rossi (attore) vs. ACME S.r.l. (convenuta)",
    field_subject: "Subject / Matter",
    field_subject_ph: "e.g. Contract termination + damages claim",
    field_facts: "Relevant facts",
    field_facts_ph: "Describe dates, amounts, breaches, communications, harm caused…",
    field_court: "Court / Authority (optional)",
    field_court_ph: "e.g. Tribunal of Milan — Business Section",
    field_context: "Additional context (optional)",
    field_context_ph: "previous attempts, strategic notes…",
    generate_cta: "Generate the act",
    kb_hint: "Top-4 most relevant notes from your Personal KB will be injected automatically.",
    generating_title: "Drafting your document",
    generating_hint: "Claude Opus 4.8 is composing in Italian legal register.",
    chars: "chars",
    kb_used: "KB notes used",
    copy: "Copy",
    print: "Print",
    save_to_kb: "Save to KB",
    new_atto: "New act",
    toast_generated: "Document ready — review and edit before filing",
    toast_copied: "Copied to clipboard",
    toast_saved_kb: "Saved to your Knowledge Base",
    err_required: "Parties, subject and facts are required",
    err_generation: "Generation failed — please retry",
    err_copy: "Copy failed",
    err_save_kb: "Could not save to KB",
    tab_create: "New act",
    tab_archive: "My acts",
    archive_search_ph: "Search by subject or parties…",
    archive_filter_all: "All types",
    archive_empty_title: "No acts yet",
    archive_empty_body: "Every act you generate gets saved here automatically. Start with a new one — it takes 60 seconds.",
    archive_empty_cta: "Generate your first act",
    archive_view: "View",
    archive_delete: "Delete",
    archive_delete_confirm: "Delete this act? This cannot be undone.",
    archive_delete_success: "Act deleted from your archive",
    archive_open_back: "Back to my acts",
    archive_count_one: "{count} act",
    archive_count_many: "{count} acts",
    archive_loading: "Loading your acts…",
    archive_load_error: "Could not load your acts",
    archive_filter_label: "Filter by type",
    upsell_title: "Atto Generator is part of Legal Pro",
    upsell_body: "Generate complete legal acts (memorie, ricorsi, pareri, diffide…) in formal Italian legal register, with Auto-KB citations injected by Claude Opus 4.8. Available on Legal Pro and Business plans.",
    upsell_cta: "Upgrade to Legal Pro",
  },
  partner: {
    title: "Partner Dashboard",
    subtitle: "Track your commissions and grow your business.",
    your_link: "Your partner link",
    copy: "Copy",
    stat_pending: "Pending",
    stat_ready: "Ready for payout",
    stat_paid: "Paid out",
    stat_lifetime: "Lifetime",
    stat_count: "Commissions",
    commissions_title: "Recent commissions",
    no_commissions: "No commissions yet. Share your link to start earning.",
    col_user: "Referred user",
    col_plan: "Plan",
    col_amount: "Amount",
    col_commission: "Commission",
    col_status: "Status",
    col_date: "Date",
    status_pending: "Pending",
    status_ready_for_payout: "Ready",
    status_paid: "Paid",
    request_payout: "Request payout",
    payout_requested: "Payout requested",
    link_copied: "Link copied",
    open_kit: "Launch kit",
    share: "Share",
  },
  partner_landing: {
    recommended_by: "Recommended by",
    hero_pretitle: "Exclusive offer · AI Platform",
    hero_title: "Bring AI into your business — in any language.",
    hero_subtitle_prefix: "Hand-picked by",
    hero_subtitle_suffix: ", NEURACOM gives you Claude, GPT and Gemini, AI image generation, document Q&A and a code builder — all under one EU-grade subscription.",
    cta_primary: "Start free — no card required",
    cta_secondary: "View pricing",
    trust_gdpr: "GDPR-friendly",
    trust_eu: "EU infrastructure",
    trust_nocard: "No credit card",
    feat_chat: "Multi-model AI Chat",
    feat_image: "Image Generation",
    feat_code: "AI Code Builder",
    feat_docs: "Document Q&A",
    results_title: "Results from real teams",
    result1_label: "Drafting time",
    result1_quote: "We cut content production time by three quarters across our marketing team.",
    result2_label: "Sales reply rate",
    result2_quote: "Personalized outbound emails 3× our reply rate in the first month.",
    result3_label: "From idea to landing page",
    result3_quote: "I described our new offer in plain text and shipped the landing page before lunch.",
    cta_title: "Start free today.",
    cta_subtitle: "Upgrade only when you ship something real.",
    cta_button: "Create your account",
    cta_attribution: "Brought to you by",
    not_found_title: "Partner link not found",
    not_found_desc: "This invitation link is invalid or has expired. Please check the URL with your partner.",
    go_home: "Go to homepage",
  },
  partner_kit: {
    back: "Back to dashboard",
    title: "Launch Kit",
    subtitle: "Everything you need to onboard your first clients. Copy, personalize, send.",
    cobranded_label: "Your co-branded landing page",
    cobranded_desc: "Send this link to leads. They land on a page that says \"Recommended by you\" and all signups are tracked to your account.",
    preview: "Preview",
    tab_email: "Email",
    tab_social: "Social",
    tab_chat: "Chat / DM",
    subject_label: "Subject",
    copy: "Copy",
    copied: "Copied!",
    no_templates: "No templates available.",
    email_cold_title: "Cold outreach",
    email_cold_subject: "An AI workspace your team will actually use",
    email_cold_body: "Hi {first_name},\n\nQuick one: are you still piecing together ChatGPT tabs, a separate image tool and Google Docs to get AI work done?\n\nI've started recommending NEURACOM — one EU-grade workspace with Claude, GPT and Gemini, image generation, document Q&A and an AI code builder. Italian, English and Polish out of the box, no setup.\n\nMy clients usually shave hours off their week in the first 5 days. You can start free, no card needed:\n\n{{LINK}}\n\nHappy to walk you through it on a 15-minute call if useful.\n\nBest,\n{{PARTNER}}",
    email_followup_title: "Follow-up (no reply)",
    email_followup_subject: "Did the NEURACOM link reach you?",
    email_followup_body: "Hi {first_name},\n\nJust bumping the email above in case it got buried. NEURACOM is the EU-based AI workspace I mentioned — multi-model chat, image gen, document Q&A and code builder, all in one place.\n\nIf 5 minutes of \"can it really replace 4 tools?\" sounds useful, here's a free account:\n\n{{LINK}}\n\nNo card. Cancel any time.\n\n{{PARTNER}}",
    email_value_title: "Value pitch (warm lead)",
    email_value_subject: "3 things NEURACOM does that ChatGPT alone doesn't",
    email_value_body: "Hi {first_name},\n\nAs promised, three NEURACOM moves that pay for the subscription in week one:\n\n1. Ask any of your PDFs questions in plain language — contracts, manuals, invoices. Cited answers, no fluff.\n2. Generate the right image for any blog/social post with Gemini Nano Banana or GPT-Image-1, right inside the same app.\n3. Describe an app or landing page in your own language → get the working HTML with one click.\n\nAll three with one EU-grade subscription, GDPR-friendly, trilingual UI (IT/EN/PL).\n\nStart free here:\n\n{{LINK}}\n\nLet me know if you want a 1:1 walkthrough.\n\n{{PARTNER}}",
    social_linkedin_title: "LinkedIn post",
    social_linkedin_body: "Most teams I talk to are using 3-4 different AI tools — and still copy-pasting between them.\n\nI've been recommending NEURACOM to my clients lately because it actually solves that:\n\n→ One workspace, three AI models (Claude / GPT / Gemini)\n→ Image generation, document Q&A and AI code builder built in\n→ EU infrastructure, GDPR-friendly, trilingual (IT/EN/PL)\n→ Transparent monthly pricing, no token surprises\n\nFree to try, no card needed:\n{{LINK}}\n\n#AI #productivity #EU",
    social_twitter_title: "Twitter / X post",
    social_twitter_body: "Stop juggling 4 AI tools.\n\nNEURACOM = Claude + GPT + Gemini + image gen + doc Q&A + code builder in one EU-based workspace.\n\nTrilingual UI. GDPR-friendly. Free to start.\n\n{{LINK}}",
    social_facebook_title: "Facebook post",
    social_facebook_body: "If you (or your team) are paying for ChatGPT, Midjourney and a couple of other AI subscriptions, look at NEURACOM. One EU-based workspace with Claude, GPT, Gemini, image generation, document Q&A and an AI code builder — Italian, English, Polish out of the box.\n\nFree to try, no credit card:\n{{LINK}}",
    chat_whatsapp_title: "WhatsApp / Telegram",
    chat_whatsapp_body: "Hey 👋 quick one — I've been using NEURACOM and it's basically Claude + GPT + Gemini + image gen + doc Q&A in one EU-based app. Free tier, no card. Think it could help your team:\n{{LINK}}",
    chat_dm_title: "LinkedIn / Slack DM",
    chat_dm_body: "Hi {first_name}, I think NEURACOM could save your team a lot of context-switching. One EU workspace for Claude / GPT / Gemini + image gen + document Q&A. Free to try (no card):\n{{LINK}}\nHappy to demo if useful.",
  },
  activity: {
    pretitle: "Activity",
    title: "Your timeline",
    subtitle: "Everything important that happens to your account, in one place. We email you the same events — this is just faster.",
    mark_all_read: "Mark all read",
    empty_title: "No events yet",
    empty_desc: "Activity will show up here as you use NEURACOM.",
    load_more: "Load more",
    action_dashboard: "Open dashboard",
    action_kit: "Open launch kit",
    action_partner: "Partner dashboard",
    action_upgrade: "View plans",
    event: {
      welcome: {
        title: "Welcome to NEURACOM",
        desc: "Your account is ready to use.",
      },
      subscription_activated: {
        title: "Subscription activated",
        desc: "{plan} plan · {amount} — 30 days of full access.",
      },
      partner_approved: {
        title: "Partner application approved",
        desc: "You're an approved partner. Time to share your kit.",
      },
      commission_earned: {
        title: "New commission",
        desc: "+{amount} from a referred {plan} subscription.",
      },
      payout_requested: {
        title: "Payout requested",
        desc: "{amount} requested — {count} commissions queued.",
      },
      payout_paid: {
        title: "Payout sent",
        desc: "{amount} transferred to your account.",
      },
      quota_warning: {
        title: "Quota almost reached",
        desc: "{pct}% of your {resource} limit used this month.",
      },
    },
  },
  admin: {
    title: "Admin Console",
    subtitle: "Manage promo codes, affiliates and commissions.",
    tab_stats: "Stats",
    tab_sources: "Sources",
    tab_promos: "Promo codes",
    tab_affiliates: "Affiliates",
    tab_commissions: "Commissions",
    stat_users: "Total users",
    stat_paid: "Paid users",
    stat_mrr: "MRR",
    stat_revenue: "Total revenue",
    stat_affiliates: "Approved affiliates",
    stat_commissions: "Pending commissions",
    promos_title: "Promo codes",
    new_promo: "New promo code",
    table_code: "Code",
    table_plan: "Plan",
    table_discount: "Discount price",
    table_max: "Max uses",
    table_used: "Used",
    table_active: "Active",
    table_actions: "Actions",
    activate: "Activate",
    deactivate: "Deactivate",
    delete: "Delete",
    create_promo_title: "Create promo code",
    f_code: "Code (e.g. SUMMER25)",
    f_plan: "Plan",
    f_discount: "Discounted price (€)",
    f_max_uses: "Max uses (leave empty for unlimited)",
    f_description: "Description (optional)",
    create: "Create",
    affiliates_title: "Affiliates",
    af_pending: "Pending applications",
    af_approved: "Approved affiliates",
    approve: "Approve",
    reject: "Reject",
    commissions_title: "Commissions",
    mark_paid: "Mark paid",
    no_data: "No data.",
    tiers_breakdown: "Tiers breakdown",
    col_date: "Date",
    col_affiliate: "Affiliate",
    col_referred: "Referred",
    col_plan: "Plan",
    col_commission: "Commission",
    col_status: "Status",
    col_action: "Action",
    app_company: "Company",
    app_web: "Web",
    app_volume: "Volume",
    app_per_month: "mo",
    promo_created: "Promo created",
    affiliate_approved: "Affiliate approved",
    affiliate_rejected: "Affiliate rejected",
    marked_paid: "Marked paid",
    sources_total_signups: "Total signups",
    sources_total_paid: "Paid signups",
    sources_total_installs: "PWA installs",
    sources_table_title: "Acquisition by source",
    sources_table_desc: "Where do your paying customers and PWA installs come from? Use this to double-down on the channels that convert.",
    sources_col_source: "Source",
    sources_col_signups: "Signups",
    sources_col_paid: "Paid",
    sources_col_installs: "Installs",
    sources_col_conv: "Paid %",
    sources_empty: "No acquisition data yet. As users sign up or install the PWA, sources will appear here.",
    sources_legend: "QR landing = visitors who arrived via the PWA QR code on the landing page. Install banner = home-screen install via floating prompt. Direct = no attribution param.",
    tab_blog: "Blog",
    blog: {
      count_drafts: "Drafts",
      count_published: "Published",
      count_total: "Total",
      gen_title: "Generate a new article with Claude",
      topic_label: "Topic",
      topic_ph: "E.g. How ex-officio nullity works after Cass. SS.UU. 26242/2014",
      keyword_label: "Primary SEO keyword",
      keyword_ph: "E.g. contract nullity ex officio",
      locale_label: "Language",
      ruling_optional: "Source ruling (optional)",
      ruling_headline: "Headline / massima",
      ruling_court: "Court",
      ruling_number: "Ruling number",
      ruling_date: "Date (YYYY-MM-DD)",
      ruling_principle: "Legal principle",
      generate_btn: "Generate draft (~30s)",
      generating: "Claude is writing…",
      gen_success: "Draft ready. Review and publish.",
      gen_error: "Generation failed. Retry.",
      reviewing_draft: "Review draft",
      editing_existing: "Edit article",
      field_title: "Title (SEO)",
      field_meta: "Meta description",
      field_keyword: "Keyword",
      field_tags: "Tags (comma-separated)",
      field_hero_url: "Hero image URL (optional)",
      field_body: "Article body (markdown)",
      save_draft_btn: "Save as draft",
      save_publish_btn: "Save & publish",
      discard_btn: "Discard",
      save_draft_success: "Draft saved",
      save_publish_success: "Article published!",
      save_error: "Save failed",
      view_live: "Article is live",
      open: "Open",
      all_posts: "All articles",
      no_posts: "No articles yet. Generate the first one above.",
      published: "Published",
      unpublished: "Moved back to draft",
      deleted: "Article deleted",
      confirm_delete: "Permanently delete \"{title}\"?",
      action_error: "Action failed",
      err_topic_short: "Topic must be at least 5 characters",
      err_missing_fields: "Fill title, meta description and body (min. 100 chars)",
      scheduler_title: "Weekly auto-blog",
      scheduler_desc: "Every Monday morning the system picks a ruling from the Jurisprudence DB, drafts an article with Claude and emails you a review link.",
      next_run: "Next run",
      corpus_used: "Corpus used",
      recipients: "Recipients",
      last_run: "Last run",
      run_now_btn: "Run now",
      running_now: "Running…",
      run_now_success: "Draft created from ruling {ruling} and emailed.",
      run_now_error: "Run failed",
      confirm_run_now: "Run a draft generation now from the next available ruling? It takes ~60 seconds.",
    },
  },
  marketplace: {
    nav: "Marketplace",
    pretitle: "PEER-TO-PEER",
    title: "The first Italian legal template marketplace.",
    subtitle: "Publish anonymized versions of your best acts. Earn every time a colleague buys.",
    cta_browse: "Browse templates",
    cta_publish: "Publish from my archive",
    public_browse_anyone: "Browsing is free for everyone. Purchasing requires Legal Pro or Business.",
    search_ph: "Search templates by title, tag, or topic…",
    filter_all_types: "All types",
    sort_recent: "Most recent",
    sort_popular: "Most popular",
    sort_price_asc: "Price: low → high",
    sort_price_desc: "Price: high → low",
    empty_title: "No templates yet",
    empty_body: "Be the first to publish — your archive is ready and the fee is just 15%.",
    card_by: "by",
    card_purchases: "{count} sold",
    card_buy_cta: "View details",
    price_from: "From",
    detail_purchases: "Purchases",
    detail_anon_badge: "AI-anonymized & reviewed by author",
    detail_buy_cta: "Buy for €{price}",
    detail_buy_locked_cta: "Upgrade to Legal Pro to buy",
    detail_owns_it: "You already own this template",
    detail_open_doc: "Open full document",
    detail_is_author: "You are the author of this template",
    detail_back: "Back to marketplace",
    detail_preview_label: "Preview (first paragraph)",
    detail_locked_hint: "The full document is unlocked after purchase.",
    publish_modal_title: "Publish to marketplace",
    publish_step_anonymize: "1. Anonymize",
    publish_step_review: "2. Review & edit",
    publish_step_meta: "3. Title, price & tags",
    publish_step_publish: "4. Publish",
    publish_anonymize_intro: "Claude will redact every name, address, fiscal code, date and amount. The legal structure and citations are preserved.",
    publish_anonymize_cta: "Anonymize with AI",
    publish_anonymize_running: "Anonymizing… (~20s)",
    publish_anonymized_label: "Anonymized text (editable)",
    publish_original_label: "Original (for reference)",
    publish_title_label: "Public title *",
    publish_title_ph: "Es. Memoria difensiva clausola vessatoria foro consumatore",
    publish_desc_label: "Description *",
    publish_desc_ph: "Explain the legal context, who this template is for, and what's included…",
    publish_tags_label: "Tags (comma-separated, max 10)",
    publish_tags_ph: "consumatore, foro, clausole vessatorie, 1341 cc",
    publish_category_label: "Category",
    publish_category_ph: "civile, lavoro, tributario…",
    publish_price_label: "Price *",
    publish_price_hint: "NEURACOM keeps 15%. You earn €{author_share} per sale.",
    publish_save_draft: "Save draft",
    publish_publish: "Publish now",
    publish_remove: "Remove from marketplace",
    publish_drafts_title: "My drafts & published",
    publish_status_draft: "Draft",
    publish_status_published: "Live",
    publish_status_removed: "Removed",
    publish_open_archive_cta: "Pick an act from your archive",
    publish_empty_archive_cta: "Generate your first act",
    toast_anonymized: "AI anonymization complete — review and edit if needed",
    toast_template_created: "Template created as draft",
    toast_template_updated: "Template updated",
    toast_template_published: "Template is now live in the marketplace",
    toast_template_removed: "Template removed",
    err_anonymize: "Anonymization failed — try again",
    err_create: "Could not create template",
    err_publish: "Could not publish template",
    err_invalid_price: "Invalid price tier",
    sales_title: "My sales",
    sales_balance_label: "Available balance",
    sales_lifetime_label: "Lifetime revenue",
    sales_sales_label: "Sales",
    sales_paid_out_label: "Paid out",
    sales_payout_threshold: "Payout threshold: €{threshold}",
    sales_payout_cta: "Request payout",
    sales_payout_below: "Reach €{threshold} to request a payout.",
    sales_payout_pending: "A payout request is already pending",
    sales_payout_modal_title: "Request payout",
    sales_payout_iban_label: "IBAN",
    sales_payout_iban_ph: "IT60 X054 2811 1010 0000 0123 456",
    sales_payout_notes_label: "Notes for the NEURACOM team (optional)",
    sales_payout_submit: "Confirm payout request",
    sales_payout_success: "Payout requested. NEURACOM will process within 3 business days.",
    sales_recent_title: "Recent sales",
    sales_payouts_title: "Payout history",
    sales_no_sales: "No sales yet — publish a template to start earning.",
    library_title: "My purchased templates",
    library_empty: "No purchases yet. Browse the marketplace to find templates that match your practice.",
    library_open: "Open",
    success_title: "Purchase complete!",
    success_body: "The template is unlocked in your library.",
    success_cta_library: "Open my library",
    success_cta_marketplace: "Back to marketplace",
    success_polling: "Confirming your payment…",
    upgrade_cta_buy: "Become Legal Pro to buy templates",
  },
  publish_from_atti: {
    button: "Publish to marketplace",
    helper: "Earn money every time a colleague buys this template.",
  },
  seo: {
    landing_title: "NEURACOM by TelcaVoIP — AI platform for European businesses & lawyers",
    landing_description: "GDPR-compliant AI workspace for European teams: multi-model chat, image & voice, code builder, document analysis. Legal Pro tier for Italian lawyers with 103-ruling jurisprudence database, Atto Generator and marketplace.",
    pricing_title: "Pricing — NEURACOM by TelcaVoIP",
    pricing_description: "Transparent monthly plans from free to €149 Legal Pro. GDPR-compliant, EU-hosted. Includes chat, image, voice, code, jurisprudence, atto generator and marketplace access.",
    marketplace_title: "Legal Template Marketplace — Italian atti by AI-powered lawyers",
    marketplace_description: "Buy or publish anonymised legal templates from Italian lawyers. Memoria difensiva, ricorsi Cassazione, pareri, diffide, recessi. From €19. Author-reviewed AI anonymisation.",
    jurisprudence_title: "Italian & EU Jurisprudence — 103 curated Cassazione + CJEU rulings",
    jurisprudence_description: "Full-text searchable database of 103 curated Italian Cassazione and EU Court of Justice rulings. Riforma Cartabia, Consumer Code, GDPR, labour, contracts.",
  },
  blog: {
    seo_title: "NEURACOM Blog — Cassazione, GDPR, Legal AI insights for lawyers",
    seo_description: "Legal analysis, ruling commentary and practical guides for Italian and European lawyers. Cassazione, CJEU, GDPR, contracts, Legal Pro workflows. Weekly updates.",
    pretitle: "LEGAL MAGAZINE",
    title: "Analysis, rulings and playbooks for the modern practice.",
    subtitle: "Ruling commentary, practical GDPR and contract guides, AI workflows for lawyers. Curated by NEURACOM by TelcaVoIP.",
    search_ph: "Search articles…",
    filter_all: "All",
    read_more: "Read article",
    empty_title: "No articles found",
    empty_body: "Check back soon — we publish new analysis every week.",
    article_singular: "article",
    article_plural: "articles",
    notfound_title: "Article not found",
    notfound_body: "The article you're looking for doesn't exist or is no longer published.",
    back_to_index: "Back to blog",
    related_title: "Keep reading",
    cta_pretitle: "TRY NEURACOM LEGAL PRO",
    cta_title: "AI + Jurisprudence + Atto Generator for your practice.",
    cta_body: "Claude Opus 4.8, 103 indexed Cassazione/CJEU rulings, forensic-Italian atto generator, personal Knowledge Base. GDPR-compliant, EU-hosted.",
    cta_button_pricing: "See Legal Pro (€149/month)",
    cta_button_jurisprudence: "Explore jurisprudence",
  },
};

export default en;
